const producttab = () => {

  jQuery(document).ready(function($){
    $('.subscribtion_variation').on('change',function(e){

        e.preventDefault();

        var $this   = $(this),
            data    = JSON.parse($(this).val()),
            $container = $this.closest('.c-producttab__carousel__item');

        $container.find('*[data-producttab-attribute="price_html"]').html(data.price_html);
        $container.find('*[data-producttab-attribute="tax_info"]').html(data.tax_info);

        if(data.attributes.attribute_dauer == 'jährlich') {
          $container.find('*[data-producttab-attribute="badge"]').removeClass('uk-hidden');
        } else {
          $container.find('*[data-producttab-attribute="badge"]').addClass('uk-hidden');
        }

        $container.find('*[data-producttab-attribute="cart_url"]').attr('href',glamyAjax.woo_cart_url+'?add-to-cart='+data.variation_id)
    });
  });

};

export default producttab;
